import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top when location changes
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <footer className="py-8 sm:py-12 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-8 mb-6 sm:mb-8">
          <Link to="/" className="text-orange-500 hover:text-orange-600 font-medium transition-colors text-sm sm:text-base min-h-[44px] flex items-center">
            Practice Dashboard
          </Link>
          <Link to="/pricing" className="text-orange-500 hover:text-orange-600 font-medium transition-colors text-sm sm:text-base min-h-[44px] flex items-center">
            Pricing
          </Link>
          <Link to="/contact" className="text-orange-500 hover:text-orange-600 font-medium transition-colors text-sm sm:text-base min-h-[44px] flex items-center">
            Contact Us
          </Link>
        </div>
        
        <div className="text-center">
          <p className="text-gray-600 text-xs sm:text-sm mb-2 sm:mb-3">
            2026© All rights reserved.
          </p>
          
          {/* Subtle profile link */}
          <div className="text-center">
            <a
              href="https://www.pavlomartinovych.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-gray-400 hover:text-gray-600 transition-colors underline min-h-[44px] inline-flex items-center"
            >
              Built by Pavlo Martinovych
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;